<ng-container *ngIf="isValidIp; then validateLocation; else ipMessage"></ng-container>

<ng-template #validateLocation>
  <ng-container *ngIf="isValidLocation; then buttons; else locationMessage"></ng-container>
</ng-template>

<ng-template #buttons>
  <ng-container *ngIf="isPhysicalItem() && !physicalRecord">
    <app-renew-checkout-button
      *ngIf="renewCheckouts && checkout?.renewable && !checkout?.renewed"
      [record]="record"
      [issueDate]="issueDate"
      (renewed)="onRenewal($event)"></app-renew-checkout-button>
  </ng-container>

  <ng-container *ngIf="physicalRecord; then physicalResource; else digitalResource"></ng-container>
  <ng-template #digitalResource>
    <div class="buttons-wrapper" [class.extra-large]="config.large" [ngClass]="textDirection" *ngIf="!recordIsImage">
      <ng-container *ngIf="!recordIsParentContainer; else rssParentContainer">
        <ng-container *ngIf="hasCheckoutFormats(); else externalResource">
          <ng-container
            *ngIf="
              !record.resourceTypes.includes('TIPO_FISICO') ||
              (record.resourceTypes.includes('TIPO_FISICO') && record.resourceTypes.length > 1)
            ">
            <ng-container *ngIf="alreadyCheckedOut(); then checkedOut; else notCheckedOut"></ng-container>
            <app-preview-button
              *ngIf="showPreviewButton()"
              [record]="record"
              [issueDate]="issueDate"
              [rssItem]="rssItem"></app-preview-button>
          </ng-container>
        </ng-container>
      </ng-container>

      <app-download-attached-resource-button
        *ngIf="showAttachedResourceButton()"
        [record]="record"
        [alone]="!hasCheckoutFormats()"></app-download-attached-resource-button>
      <app-favorite-button *ngIf="showFavoriteButton()" [record]="record"></app-favorite-button>
      <app-add-to-list-button *ngIf="showAddToListButton()" [record]="record"></app-add-to-list-button>

      <app-calendar-button
        *ngIf="config.calendar && isSubscription() && isInfoPage"
        [record]="record"
        [issueDate]="issueDate"
        [issueDates]="getIssueDates()">
      </app-calendar-button>

      <app-follow-button
        *ngIf="showFollowButton()"
        [attr.dir]="textDirection"
        [record]="record"
        [issueDate]="issueDate"
        [rssItem]="rssItem"
        (disableRecord)="disableRecord($event)">
      </app-follow-button>
    </div>
    <div class="buttons-wrapper" [class.extra-large]="config.large" [ngClass]="textDirection" *ngIf="recordIsImage">
      <ng-container *ngIf="physicalRecord; then physicalResource"></ng-container>
      <app-visualize-image-button
        *ngIf="showVisualizeImageButton"
        [record]="record"
        [callback]="visualizeImageButtonCallback"></app-visualize-image-button>
      <app-download-attached-resource-button
        *ngIf="showAttachedResourceButton()"
        [record]="record"></app-download-attached-resource-button>
    </div>
  </ng-template>

  <ng-template #checkedOut>
    <app-download-button [record]="record" [issueDate]="issueDate" [rssItem]="rssItem"></app-download-button>
    <app-renew-checkout-button
      *ngIf="renewCheckouts && checkout?.renewable && !checkout?.renewed"
      [record]="record"
      [issueDate]="issueDate"
      (renewed)="onRenewal($event)"></app-renew-checkout-button>
    <app-return-button
      *ngIf="config.return"
      [record]="record"
      [issueDate]="issueDate"
      [rssItem]="rssItem"></app-return-button>
  </ng-template>

  <ng-template #notCheckedOut>
    <ng-template *ngIf="record.active; then activeRecord; else inactiveRecord"></ng-template>
  </ng-template>

  <ng-template #activeRecord>
    <ng-template *ngIf="alreadyInHold(); then inHold; else notInHold"></ng-template>
  </ng-template>

  <ng-template #inactiveRecord>
    <app-certificate-button
      *ngIf="historyItem && historyItem.record.learningExperienceId && historyItem.urlCertificate"
      class="history-button"
      style="margin-bottom: 16px"
      [historyItem]="historyItem"></app-certificate-button>
    <div class="not-available-wrapper">
      <span class="not-available">{{ 'messages.error.discharged' | translate }}</span>
    </div>
  </ng-template>

  <ng-template #inHold>
    <app-checkout-button
      *ngIf="getHold()?.status === 'informed'"
      [record]="record"
      [issueDate]="issueDate"
      [rssItem]="rssItem"></app-checkout-button>
    <app-cancel-hold-button
      *ngIf="getHold()?.status === 'waiting'"
      [record]="record"
      [issueDate]="issueDate"
      [rssItem]="rssItem"></app-cancel-hold-button>
  </ng-template>

  <ng-template #notInHold>
    <ng-container *ngIf="!availability; else availabilityTemplate">
      <app-waiting-button></app-waiting-button>
    </ng-container>

    <ng-template #availabilityTemplate>
      <app-checkout-button
        *ngIf="showCheckoutButton()"
        [attr.dir]="textDirection"
        [record]="record"
        [issueDate]="issueDate"
        [rssItem]="rssItem"
        (disableRecord)="disableRecord($event)"></app-checkout-button>

      <app-hold-button
        *ngIf="showHoldButton()"
        [attr.dir]="textDirection"
        [record]="record"
        [issueDate]="issueDate"
        [rssItem]="rssItem"></app-hold-button>

      <ng-container *ngIf="certificateSection && historyItem?.urlCertificate">
        <app-download-button [record]="historyItem?.record" [historyItem]="historyItem" [certificateItem]="true">
        </app-download-button>
      </ng-container>
    </ng-template>
  </ng-template>

  <ng-template #physicalResource>
    <ng-container
    *ngIf="physicalRecord.holdInfo === holdStatus.AVAILABLE
    || physicalRecord.Reservas === holdStatus.AVAILABLE
    || physicalRecord['Préstamos'] === holdStatus.AVAILABLE
    || physicalRecord['Préstec'] === holdStatus.AVAILABLE
    && physicalRecord.holdInfo !== holdStatus.ALREADY_HELD">
      <app-hold-physical-button [attr.dir]="textDirection"
                                [record]="record"
                                [physicalRecord]="physicalRecord"
                                [issueDate]="issueDate"
                                [rssItem]="rssItem"></app-hold-physical-button>
    </ng-container>
    <ng-container *ngIf="physicalRecord.availability === holdStatus.ALREADY_HELD">
      <app-cancel-hold-physical-button
        [record]="record"
        [physicalRecord]="physicalRecord"
        [issueDate]="issueDate"
        [rssItem]="rssItem"></app-cancel-hold-physical-button>
    </ng-container>
  </ng-template>

  <ng-template #externalResource>
    <ng-template *ngIf="record?.active; then activeExternal; else inactiveRecord"></ng-template>
  </ng-template>

  <ng-template #activeExternal>
    <app-external-link-button *ngIf="record?.externalLink" [from]="from" [record]="record"></app-external-link-button>
    <app-certificate-button
      *ngIf="historyItem && historyItem.record.learningExperienceId && historyItem.urlCertificate"
      class="history-button"
      [historyItem]="historyItem"></app-certificate-button>
  </ng-template>

  <ng-template #rssParentContainer>
    <app-view-all-button [record]="record"></app-view-all-button>
  </ng-template>

  <ng-template #followList>
    <app-follow-button
      [attr.dir]="textDirection"
      [record]="record"
      [issueDate]="issueDate"
      [rssItem]="rssItem"
      (disableRecord)="disableRecord($event)"></app-follow-button>
  </ng-template>
</ng-template>

<ng-template #ipMessage>
  <span class="not-available">{{ 'general.invalidIp' | translate }}</span>
</ng-template>

<ng-template #locationMessage>
  <span class="not-available">{{ 'general.invalidLocation' | translate }}</span>
</ng-template>
